import { render, staticRenderFns } from "./Pronostico.vue?vue&type=template&id=1f6ec420&"
import script from "./Pronostico.vue?vue&type=script&lang=js&"
export * from "./Pronostico.vue?vue&type=script&lang=js&"
import style0 from "./Pronostico.vue?vue&type=style&index=0&id=1f6ec420&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports